import { useNavigate, useParams } from 'react-router-dom';

import { Report as ReportFeature } from '../../../features/reports/report';

const Report = () => {
  const { referralId, referralSessionId, '*': path } = useParams();
  const navigate = useNavigate();

  if (!referralId) throw new Error('no referral id');

  return (
    <ReportFeature
      navigateToPath={navigate}
      path={path}
      referralId={referralId}
      referralSessionId={referralSessionId}
    />
  );
};

export { Report };
